import gql from 'graphql-tag';

export default gql`
  fragment eventScheduleFragment on EventScheduleType {
    id
    eventId
    eventDate
    eventDateText
    eventDateTextFull
    eventDateWday
    startTime
    startTimeText
    endTime
    endTimeText
  }
`;
